import React from 'react'
import Hero from '../components/Hero'
import AboutSection from '../components/AboutSection'
import ProjectSection from '../components/ProjectSection'
import SkillSection from '../components/SkillSection'
import ContactSection from '../components/ContactSection'
import ExperienceSection from '../components/ExperienceSection'
import EducationSection from '../components/EduacationSection'
import CoursesSection from '../components/CoursesSection'


const Home = () => {
  return (
    <div>
        <Hero/>
        <AboutSection/>
        <ExperienceSection/>
        <EducationSection/>
        <ProjectSection/>
        <SkillSection/>
        <CoursesSection/>
        <ContactSection/>
    </div>
  )
}

export default Home